import React from "react";
import Grid from "@material-ui/core/Grid";
import { Droppable } from "react-beautiful-dnd";
import Task from "./Task";

const Column = ({ selected, addData, handleChangeCheckNew, handleDelete }) => {

  const routeId = (selected ? selected.routeId : '') || 'new'

  return (
    <Droppable droppableId={`column-${routeId}`}>
      {provided => (
        <Grid
          container
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {addData.map((res, index) => (
            <Task
              key={`${selected.routeId}-${res.collectPointId}`}
              routeId={routeId}
              val={res}
              index={index}
              handleChangeCheckNew={handleChangeCheckNew}
              handleDelete={() => handleDelete(index)}
            />
          ))}
          {provided.placeholder}
        </Grid>
      )}
    </Droppable>
  );
};

export default Column;
